import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PendingChangesGuard } from '../+shared/guards/pending-changes-guard.servie';
import { translateModule } from '../+shared/shared.translate.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  CalendarModule,
  CardModule,
  CheckboxModule,
  DropdownModule,
  FileUploadModule,
  InputNumberModule,
  InputTextModule,
  RadioButtonModule,
} from 'primeng';
import { CommonModule, JsonPipe } from '@angular/common';
import { DropDownComponent } from './components/drop-down/drop-down.component';
import { RadioButtonGroupComponent } from './components/radio-button-group/radio-button-group.component';
import { InputComponent } from './components/input/input.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { RadioButtonYesNoComponent } from './components/radio-button-yes-no/radio-button-yes-no.component';
import { FileInputFormControlComponent } from './components/file-input-form-control/file-input-form-control.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { ErrorsComponent } from './components/errors/errors.component';
import { NoteComponent } from './components/note/note.component';
import { ApplicationHeaderComponent } from './components/other/application-header/application-header.component';
import { PageHeaderComponent } from './components/other/page-header/page-header.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';

@NgModule({
  declarations: [
    DropDownComponent,
    RadioButtonGroupComponent,
    InputComponent,
    InputNumberComponent,
    CheckboxComponent,
    RadioButtonYesNoComponent,
    FileInputFormControlComponent,
    ErrorsComponent,
    NoteComponent,
    ApplicationHeaderComponent,
    PageHeaderComponent,
    DatePickerComponent,
  ],
  imports: [
    translateModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    CommonModule,
    InputNumberModule,
    RadioButtonModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    FileUploadModule,
    CardModule,
    CalendarModule,
  ],
  providers: [PendingChangesGuard, JsonPipe],
  exports: [
    DropDownComponent,
    RadioButtonGroupComponent,
    InputComponent,
    InputNumberComponent,
    CheckboxComponent,
    RadioButtonYesNoComponent,
    FileInputFormControlComponent,
    NoteComponent,
    ApplicationHeaderComponent,
    PageHeaderComponent,
    DatePickerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomControlsModule {}
